import React, { Component } from 'react';
import './Announcement.css';

export class BuildingCleaning extends Component {
    render() {
        return <div>
        <div className="panel panel-default">
            <div className="panel-heading">
                <span className="panel-title">Building Cleaning</span>
            </div>
            <div className="panel-body">
            <table className="table table-responsive table-striped">
                <thead>
                    <tr>
                        <td><strong>Date</strong></td>
                        <td><strong>Leader</strong></td>
                        <td><strong>Participants</strong></td>
                    </tr>
                </thead>
                <tbody>
                    <BuildingCleaningItem date="2020/03/08" leader="Purcell" families="Bass, Nishime, Olsen, Perry, Yip, Eric Smith" />
                    <BuildingCleaningItem date="2020/03/15" leader="Go" families="Baun, Kirkwood, Knegt, Lau, Wettstein, Rippon" />
                    <BuildingCleaningItem date="2020/03/22" leader="Felt" families="Abbott, Boatright, Carroll, Jones, D. Ludden, Richardson" />     
                    <BuildingCleaningItem date="2020/03/29" leader="Seamons" families="Avila, Deverich, H. Campbell, Oshima, Walker, Zanatta" />               
                </tbody>
            </table>
            </div>
        </div>
    </div>;
    }
}

export class BuildingCleaningItem extends Component {
    render() {
        return <tr>
        <td>{new Date(this.props.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric'})}</td>
        <td>{this.props.leader}</td>
        <td>{this.props.families}</td>
    </tr>;
    }
}

export default BuildingCleaning;